var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};
// Override Settings
var boostPFSFilterConfig = {
  general: {
    limit: boostPFSThemeConfig.custom.products_per_page,
    /* Optional */
    loadProductFirst: true,
    numberFilterTree: 2,
    filterTreeMobileStyle: "style1",
    // Replaced by the theme's own scroll restoration below: Boost's version only binds the
    // items of its first API page (Liquid renders more) and rewrites the URL to ?page=N.
    enableKeepScrollbackPosition: false,
  },
};

(function () {
  BoostPFS.inject(this);

  // Declare Templates
  var boostPFSTemplate = {
    // Grid Template
    productGridItemHtml:
      '<div class="grid-item product-item product-item--left product-item--outer-text">' +
      '<div class="product-item__image double__image"' +
      "{{bgColor}}" +
      ">" +
      "{{itemImages}}" +
      "</div>" +
      "{{itemInfo}}" +
      "{{itemLabels}}" +
      "</div>",

    // Pagination Template
    previousActiveHtml:
      '<a class="Pagination__NavItem Link Link--primary" rel="prev" href="{{itemUrl}}"><svg class="{{ icon_class }}" role="presentation" viewBox="0 0 11 18"><path d="M9.5 1.5L1.5 9l8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path></svg></a>',
    previousDisabledHtml: "",
    nextActiveHtml:
      '<a class="Pagination__NavItem Link Link--primary" rel="next" href="{{itemUrl}}"><svg class="{{ icon_class }}" role="presentation" viewBox="0 0 11 18"><path d="M1.5 1.5l8 7.5-8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path> </svg></a>',
    nextDisabledHtml: "",
    pageItemHtml: '<a class="Pagination__NavItem Link Link--primary" href="{{itemUrl}}">{{itemTitle}}</a>',
    pageItemSelectedHtml: '<span class="Pagination__NavItem is-active">{{itemTitle}}</span>',
    pageItemRemainHtml: '<span class="Pagination__NavItem">{{itemTitle}}</span>',
    paginateHtml:
      ' <div class="Pagination Text--subdued"><div class="Pagination__Nav">{{previous}}{{pageItems}}{{next}}</div></div>',
    // Sorting Template
    sortingHtml: "{{sortingItems}}",
  };

  /************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  function prepareShopifyData(data) {
    // Displaying price base on the policy of Shopify, have to multiple by 100
    soldOut = !data.available; // Check a product is out of stock
    onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Convert images to array
    images = data.images_info;
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data["variants"][0];
    if (Utils.getParam("variant") !== null && Utils.getParam("variant") != "") {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam("variant");
      });
      if (typeof paramVariant[0] !== "undefined") firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data["variants"].length; i++) {
        if (data["variants"][i].available) {
          firstVariant = data["variants"][i];
          break;
        }
      }
    }
    return data;
  }
  /************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  /************************** BUILD PRODUCT LIST **************************/
  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function (data, index) {
    if (!data) data = this.data;
    if (!index) index = this.index;
    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;
    // Customize API data to get the Shopify data
    data = prepareShopifyData(data);
    // Add Custom class
    var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : "";
    var saleClass = onSale ? boostPFSTemplate.saleClass : "";

    // Get Background Color
    itemHtml = itemHtml.replace(/{{bgColor}}/g, getBackgroundColor());

    // Add Label
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));

    // Add Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImage(data, images));

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemInfo}}/g, buildInfo(data, index));

    // Add Reviews
    if (typeof Integration === "undefined" || !Integration.hascompileTemplate("reviews")) {
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, "");
    }
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
    return itemHtml;
  };

  /************************** END BUILD PRODUCT LIST **************************/
  /************************** BUILD PRODUCT ITEM ELEMENTS **************************/
  function buildClass() {
    return boostPFSThemeConfig.custom.filter_position == "drawer" ? "lap-and-up" : "desk";
  }

  function buildClassHiz() {
    return boostPFSThemeConfig.custom.use_horizontal ? "fProductItem--horizontal" : "";
  }

  function buildButtonSecond() {
    return boostPFSThemeConfig.custom.use_horizontal
      ? '<a href="{{itemUrl}}" class="ProductItem__ViewButton Button Button--secondary hidden-pocket">' +
          boostPFSThemeConfig.label.view_product +
          "</a>"
      : "";
  }

  function getBackgroundColor() {
    var bgColor = "";

    if (jQ(".collection.collection-products").length) {
      var sectionSettings = jQ(".collection.collection-products").data("section-settings");

      if (sectionSettings?.collectionBackgroundColor) {
        bgColor = 'style="background-color:' + sectionSettings.collectionBackgroundColor + '"';
      }
    }

    return bgColor;
  }

  function buildImage(data, images) {
    var htmlImg = "";
    if (!images) images = [];
    if (images.length == 0) {
      images.push({
        src: boostPFSConfig.general.no_image_url,
        id: data.id,
        width: 480,
        height: 480,
      });
    }

    if (images.length > 0) {
      var sizes = "136,160,180,220,254,270,284,292,320,460,480,528,568,584,640,920,1056,1280,1840";
      var support_size = imageSize(sizes, images[1]);
      var thumbUrl = Utils.optimizeImage(images[1]["src"], "640x");

      var sizes_main = "136,160,180,220,254,270,284,292,320,460,480,528,568,584,640,920,1056,1280,1840";
      var support_size = imageSize(sizes_main, images[0]);
      var thumbUrl_main = images.length > 0 ? Utils.optimizeImage(images[0]["src"], "640x") : boostPFSConfig.general.no_image_url;

      htmlImg += `<a class="product-link" href="{{itemUrl}}">
      <div class="product-item__bg" data-product-image-default="">`;

      htmlImg += `<figure class="image-wrapper image-wrapper--cover lazy-image lazy-image--backfill is-loading" style="--aspect-ratio: 1;--aspect-ratio-mobile: 1;" data-aos="img-in" data-aos-delay="0" data-aos-duration="800" data-aos-easing="ease-out-quart">
      
      <img loading="lazy" class="is-loading" src="${thumbUrl_main}" srcset="${thumbUrl_main}" data-widths="[${support_size}]" data-sizes="auto" alt="${data.title}" data-image-id="${images[1].id}" sizes = "(min-width: 1400px) calc(100vw / 4), (min-width: 750px) calc(100vw / 2), (min-width: 480px) calc(100vw / 2), calc(100vw / 2)">

      </figure>`;

      htmlImg += `</div>`;

      htmlImg += `<div class="product-item__bg__under">
    
      <figure class="image-wrapper image-wrapper--cover lazy-image lazy-image--backfill is-loading" style="--aspect-ratio: 1;--aspect-ratio-mobile: 1;" data-aos="img-in" data-aos-delay="0" data-aos-duration="800" data-aos-easing="ease-out-quart">
      
      <img loading="lazy" class="is-loading" src="${thumbUrl}" srcset="${thumbUrl}" data-widths="[${support_size}]" data-sizes="auto" alt="${data.title}" data-image-id="${images[1].id}" sizes = "(min-width: 1400px) calc(100vw / 4), (min-width: 750px) calc(100vw / 2), (min-width: 480px) calc(100vw / 2), calc(100vw / 2)">

      </figure>
    </div>`;

      htmlImg += `</a >`;
    }
    return htmlImg;
  }

  function imageSize(sizes, image) {
    if (image) {
      var desired_sizes = sizes.split(",");
      var supported_sizes = "";
      for (var k = 0; k < desired_sizes.length; k++) {
        var size = desired_sizes[k];
        var size_as_int = size * 1;
        if (image.width < size_as_int) {
          break;
        }
        supported_sizes = supported_sizes + size + ",";
      }

      if (supported_sizes == "") supported_sizes = image.width;

      if (!jQ.isNumeric(supported_sizes)) {
        supported_sizes = supported_sizes.split(",").join(",");
        supported_sizes = supported_sizes.substring(0, supported_sizes.lastIndexOf(","));
      }
      return supported_sizes;
    } else {
      return "";
    }
  }

  function buildPrice(data) {
    var html = "";
    // var show_price_on_hover = boostPFSThemeConfig.custom.product_show_price_on_hover;
    // var show_compare_price = boostPFSThemeConfig.custom.show_compare_price;
    var show_compare_price = true;

    html += `<div class="product-item__price">`;

    if (onSale) {
      html += `<span class="price sale">`;

      html += `<span class="new-price">
        <span class="money">$${data.price_min}</span>
      </span>`;

      if (show_compare_price) {
        html += `<span class="old-price"><span class="money">$${data.compare_at_price_min}</span></span>`;
      }

      html += `</span>`;
    } else {
      if (priceVaries) {
        html += `<span class="price sale"><span class="new-price"><span class="new-price">${boostPFSThemeConfig.label.from} $${data.price_min}</span></span></span>`;
      } else {
        html += `<span class="price sale"><span class="new-price"><span class="new-price">$${data.price_min}</span></span></span>`;
      }
    }
    html += "</div>";
    return html;
  }

  function buildLabels(data) {
    var html = "";
    var product_labels = "";
    if (boostPFSThemeConfig.custom.show_labels) {
      product_labels = "";
      var tags = data.tags;
      for (var k = 0; k < tags.length; k++) {
        var tag = tags[k];
        if (tag.indexOf("__label_collection") != -1) {
          product_labels +=
            '<span class="111 ProductItem__Label Heading Text--subdued">' + tag.split("__label_collection:")[1] + "</span>";
          break;
        }
      }
      // 			if (!soldOut) {
      // 				if (onSale)
      // 					product_labels += '<span class="ProductItem__Label Heading Text--subdued">' + boostPFSThemeConfig.label.sale + '</span>';
      // 			} else {
      // 				product_labels += ' <span class="ProductItem__Label Heading Text--subdued">' + boostPFSThemeConfig.label.sold_out + '</span>';
      // 			}

      if (soldOut) {
        product_labels +=
          ' <span class="ProductItem__Label Heading Text--subdued">' + boostPFSThemeConfig.label.sold_out + "</span>";
      }

      if (product_labels != "") {
        html += '<div class="ProductItem__LabelList">';
        html += product_labels;
        html += "</div>";
      }
    }
    return html;
  }

  function buildInfo(data, indx) {
    var html = "";
    if (boostPFSThemeConfig.custom.show_product_info) {
      html += `
      <div class="product-information" data-product-information="">
        <div class="product-item__info">
          <a
            class="product-link"
            href="{{itemUrl}}"
            aria-label="${data.title}"
            data-product-link="{{itemUrl}}"
            ><p class="product-item__title">${data.title}</p>

            <div class="product-item__price__holder">
              ${buildPrice(data)}
            </div>
          </a>
        </div>
      </div>
    `;
    }

    return html;
  }

  function buildSwatch(data, indx) {
    var itemSwatchHtml = "";
    if (boostPFSThemeConfig.custom.show_color_swatch) {
      var color_name = boostPFSThemeConfig.custom.section_id + "-" + data.id + "-" + indx;
      data.options_with_values.forEach(function (option, index) {
        var option_name = option.name.toLowerCase();
        if (option_name.indexOf("color") != -1 || option_name.indexOf("colour") != -1 || option_name.indexOf("couleur") != -1) {
          var values = "";
          itemSwatchHtml += '<div class="ProductItem__ColorSwatchList">';
          var i = 0;
          data.variants.forEach(function (variant) {
            var temp = variant.merged_options.filter(function (obj) {
              obj = obj.toLowerCase();
              if (obj.indexOf("color") != -1 || obj.indexOf("colour") != -1) return obj;
            });
            temp = temp[0].split(":");

            var value = temp[1].toLowerCase();
            if (values.indexOf(value) == -1) {
              values = values + "," + value;
              values = values.split(",");
              var size = "200,400,600,700,800,900,1000,1200";
              var supported_sizes = imageSize(size, variant.image);
              var color_image = Utils.optimizeImage(variant.image);
              var name_color = Utils.slugify(value) + ".png";
              var checked = i == 0 ? "checked=checked" : "";
              var imageInfo = null;
              var image_aspect_ratio = 1;
              imageInfo = data.images_info.find(function (imageOb) {
                if (imageOb.src == variant.image) {
                  image_aspect_ratio = imageOb.width / imageOb.height;
                  return imageOb;
                }
              });
              if (!imageInfo) {
                if (data.images_info.length > 0) {
                  imageInfo = data.images_info[0];
                } else {
                  imageInfo = {
                    src: boostPFSConfig.general.no_image_url,
                    id: variant.id,
                    width: 480,
                    height: 480,
                  };
                }
              }
              var dataImg =
                imageInfo != null
                  ? '" data-image-url="' +
                    imageInfo.src +
                    '" data-image-widths="[' +
                    supported_sizes +
                    ']" data-image-aspect-ratio="1" data-image-id="' +
                    imageInfo.id +
                    '"'
                  : "";
              var color_input_id = color_name + "-" + values.length;
              var variant_price = variant.price ? variant.price : 0;
              var variant_compare_at_price = variant.compare_at_price ? variant.compare_at_price : 0;
              var url_color = Utils.getFilePath(
                Utils.slugify(value),
                Globals.swatchExtension,
                Settings.getSettingValue("general.swatchImageVersion")
              );
              itemSwatchHtml += '<div class="ProductItem__ColorSwatchItem">';
              itemSwatchHtml +=
                '<input class="ColorSwatch__Radio" type="radio" ' +
                checked +
                ' name="' +
                color_name +
                '" id="' +
                color_input_id +
                '" value="' +
                value +
                '" data-image-aspect-ratio="' +
                image_aspect_ratio +
                '" data-variant-price="' +
                variant_price +
                '" data-variant-compare-at-price="' +
                variant_compare_at_price +
                '" data-variant-url="' +
                Utils.buildProductItemUrl(data) +
                "?variant=" +
                variant.id +
                "#Image" +
                imageInfo.id +
                '"' +
                dataImg +
                '  aria-hidden="true">';
              itemSwatchHtml +=
                '<label class="ColorSwatch ColorSwatch--small" for="' +
                color_input_id +
                '" style="background-color: ' +
                value.replace(" ", "").toLowerCase() +
                "; background-image: url(" +
                url_color +
                ')" title="' +
                value +
                '" data-tooltip="' +
                value +
                '"></label>';
              itemSwatchHtml += "</div>";
              i++;
            }
          });
          itemSwatchHtml += "</div>";
        }
      });
    }
    return itemSwatchHtml;
  }
  /************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
  /************************** BUILD TOOLBAR **************************/
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

    if (totalPage > 1) {
      var paginationHtml = boostPFSTemplate.paginateHtml;
      // Build Previous
      var previousHtml = currentPage > 1 ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
      previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink("page", currentPage, currentPage - 1));
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
      // Build Next
      var nextHtml = currentPage < totalPage ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
      nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink("page", currentPage, currentPage + 1));
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
      // Create page items array
      var beforeCurrentPageArr = [];
      for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift("...");
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1);
      }
      beforeCurrentPageArr.push(currentPage);
      var afterCurrentPageArr = [];
      for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push("...");
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }
      // Build page items
      var pageItemsHtml = "";
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == "...") {
          pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
        } else {
          pageItemsHtml += pageArr[iPage] == currentPage ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink("page", currentPage, pageArr[iPage]));
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
      return paginationHtml;
    }

    return "";
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    var html = "";
    if (boostPFSThemeConfig.custom.show_sorting && boostPFSTemplate.hasOwnProperty("sortingHtml")) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        // Build content
        var sortingItemsHtml = "";
        for (var k in sortingArr) {
          var classActive = Globals.queryParams.sort == k ? "is-selected" : "";
          sortingItemsHtml +=
            '<button class="Popover__Value ' +
            classActive +
            ' Heading Link Link--primary u-h6" data-value="' +
            k +
            '">' +
            sortingArr[k] +
            "</button>";
        }
        html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      }
    }
    return html;
  };

  // Build Sorting event
  ProductSorting.prototype.bindEvents = function () {
    var topSortingSelector = jQ(Selector.topSorting);
    topSortingSelector.find(".Popover__Value").click(function (e) {
      FilterApi.setParam("sort", jQ(this).data("value"));
      FilterApi.setParam("page", 1);
      FilterApi.applyFilter("sort");
      jQ(".CollectionToolbar__Item--sort").trigger("click");
    });
  };
  /************************** END BUILD TOOLBAR **************************/

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function (data, eventType) {
    if (!data) data = this.data;
    if (!eventType) eventType = this.eventType;
    /**
		 *  Call theme function 
		 *  1. Add var bcPrestigeSections; var bcPrestigeSectionContainer; to assets/theme.min.js
		 *  2. In assets/theme.min.js, find var YYY=new XXX.SectionContainer; For example: var e=new o.SectionContainer;
		 *  3. Replace var e=new o.SectionContainer; by var e=new o.SectionContainer; var YYY = new XXX.SectionContainer;  bcPrestigeSections = YYY; bcPrestigeSectionContainer = XXX;
		
		if(typeof bcPrestigeSectionContainer != 'undefined' && typeof bcPrestigeSections != 'undefined'){
		bcPrestigeSections.register("collection", bcPrestigeSectionContainer.CollectionSection);
		bcPrestigeSections.register("search", bcPrestigeSectionContainer.SearchSection);
		}  
		*/

    // Fix image not load on Instagram browser - initialize swatch image
    jQ(".ProductItem__Info .ProductItem__ColorSwatchList .ProductItem__ColorSwatchItem label.ColorSwatch").click(function () {
      jQ(this).parent().parent().find("label.ColorSwatch").removeClass("active");
      jQ(this).addClass("active");
      var parent = jQ(this).parent();
      var productImage = jQ(this).parent().parent().parent().parent().find("a.ProductItem__ImageWrapper");
      var variantInfo = parent.find("input.ColorSwatch__Radio");
      productImage.find(".AspectRatio .bc-sf-product-swatch-img").remove();
      productImage
        .find(".AspectRatio")
        .prepend('<img class="bc-sf-product-swatch-img" src="' + variantInfo.data("image-url") + '" />');
      productImage.find("img.ProductItem__Image").hide();
      productImage.attr("href", variantInfo.data("variant-url"));
      var variantPrice = "";
      if (variantInfo.data("variant-compare-at-price") > variantInfo.data("variant-price")) {
        variantPrice +=
          '<span class="ProductItem__Price Price Price--highlight Text--subdued" data-money-convertible="">' +
          Utils.formatMoney(variantInfo.data("variant-price")) +
          "</span>";
        variantPrice +=
          '<span class="ProductItem__Price Price Price--compareAt Text--subdued" data-money-convertible="">' +
          Utils.formatMoney(variantInfo.data("variant-compare-at-price")) +
          "</span>";
      } else {
        variantPrice +=
          '<span class="ProductItem__Price Price Text--subdued" data-money-convertible>' +
          Utils.formatMoney(variantInfo.data("variant-price")) +
          "</span>";
      }
      jQ(this).closest(".ProductItem__Wrapper").find(".ProductItem__PriceList").html(variantPrice);
    });

    //Change view layout
    var desktopView = jQ(".CollectionToolbar__LayoutSwitch.hidden-phone").find(".is-active").data("count");
    if (desktopView && desktopView != parseInt(boostPFSThemeConfig.custom.desktop_row)) {
      jQ(Selector.products + " .Grid__Cell").removeClass(
        "1/" +
          boostPFSThemeConfig.custom.tablet_row +
          "--tablet-and-up 1/" +
          boostPFSThemeConfig.custom.desktop_row +
          "--" +
          buildClass()
      );
      jQ(Selector.products + " .Grid__Cell").addClass(
        "1/" + desktopView + "--tablet-and-up 1/" + desktopView + "--" + buildClass()
      );
    }
    var mobileView = jQ(".CollectionToolbar__LayoutSwitch.hidden-tablet-and-up").find(".is-active").data("count");
    if (mobileView && mobileView != parseInt(boostPFSThemeConfig.custom.mobile_row)) {
      jQ(Selector.products + " .Grid__Cell").removeClass("1/" + boostPFSThemeConfig.custom.mobile_row + "--phone");
      jQ(Selector.products + " .Grid__Cell").addClass("1/" + mobileView + "--phone");
    }
  };

  // Build additional elements
  FilterResult.prototype.afterRender = function (data, eventType) {
    if (!data) data = this.data;
    if (!eventType) eventType = this.eventType;
  };

  // Build Default layout
  Filter.prototype.errorFilterCallback = function () {
    var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
      isSafari = /Safari/.test(navigator.userAgent),
      isBackButton = window.performance && window.performance.navigation && 2 == window.performance.navigation.type;
    if (!(isiOS && isSafari && isBackButton)) {
      var self = this,
        url = window.location.href.split("?")[0],
        searchQuery = self.isSearchPage() && self.queryParams.hasOwnProperty("q") ? "&q=" + self.queryParams.q : "";
      window.location.replace(url + "?view=bc-original" + searchQuery);
    }
  };
})();

/************************** KEEP SCROLL POSITION ON BACK NAVIGATION **************************/
// Returning from a product to the collection/search page puts the customer back where they were.
(function () {
  var isInfiniteScroll = false;
  try {
    isInfiniteScroll = boostPFSAppConfig.settings.general.paginationType === "infinite";
  } catch (e) {}

  // Infinite scroll pushes ?page=N into history, so going back reloads only page N at the top.
  // Keep the URL on the listing instead (filters and sorting stay) and replace the entry.
  if (isInfiniteScroll && window.URL) {
    var pushState = history.pushState;
    history.pushState = function (state, title, url) {
      if (url) {
        var next = new URL(url, window.location.href);
        if (next.searchParams.has("page")) {
          next.searchParams["delete"]("page");
          url = next.href;
          if (next.pathname + next.search === window.location.pathname + window.location.search) {
            return history.replaceState(state, title, url);
          }
        }
      }
      return pushState.call(history, state, title, url);
    };
  }

  // Read back by snippets/boost-pfs.liquid with the same key.
  function storageKey() {
    return "manssionScrollY:" + window.location.pathname + window.location.search;
  }

  window.addEventListener("pagehide", function () {
    try {
      window.sessionStorage.setItem(storageKey(), String(Math.round(window.scrollY)));
    } catch (e) {}
  });

  if ("scrollRestoration" in history) history.scrollRestoration = "manual";

  // iOS Safari brings the listing back from the back/forward cache: this script does not run again,
  // and with manual scrollRestoration WebKit leaves the restored page at the top.
  window.addEventListener("pageshow", function (event) {
    if (!event.persisted) return;
    var cachedY = 0;
    try {
      cachedY = parseInt(window.sessionStorage.getItem(storageKey()), 10);
    } catch (e) {}
    if (cachedY > 0) restoreScroll(cachedY);
  });

  // Set by snippets/boost-pfs.liquid on back/reload navigations, which also hides #MainContent.
  if (window.manssionRestoreScrollY > 0) restoreScroll(window.manssionRestoreScrollY);

  function restoreScroll(savedY) {
    // Products render asynchronously (Boost API, infinite scroll pages, images), so keep applying the
    // position until the page is tall enough and its height has settled, or the customer takes over.
    var deadline = Date.now() + 8000;
    var lastHeight = 0;
    var stableSince = Date.now();
    var cancelled = false;
    var cancelEvents = ["touchstart", "wheel", "mousedown", "keydown"];

    function reveal() {
      document.documentElement.classList.remove("is-restoring-scroll");
    }

    function cancel() {
      cancelled = true;
      reveal();
      cancelEvents.forEach(function (name) {
        window.removeEventListener(name, cancel);
      });
    }
    cancelEvents.forEach(function (name) {
      window.addEventListener(name, cancel, { passive: true });
    });

    (function restore() {
      if (cancelled) return;
      var height = document.documentElement.scrollHeight;
      if (height !== lastHeight) {
        lastHeight = height;
        stableSince = Date.now();
      }
      // When the page is still shorter than the saved position this scrolls to the bottom,
      // which makes infinite scroll load the next page of products.
      window.scrollTo({ top: savedY, behavior: "instant" });
      var reached = Math.abs(window.scrollY - savedY) < 2;
      var stableFor = Date.now() - stableSince;
      // Fade the listing in once it sits at the saved position and the layout has settled,
      // then keep holding it there a little longer for late image or Boost layout shifts.
      if (reached && stableFor > 400) reveal();
      if ((reached && stableFor > 1500) || Date.now() > deadline) return cancel();
      requestAnimationFrame(restore);
    })();
  }
})();
